import React from 'react';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import SwirlIllustrations from '../../SwirlIllustrations';
import Wrapper from './Wrapper';

import './style.scss';

// Subcomponents.
import Actions from './Actions';
import Count from './Count';
import Header from './Header';
import RadioButtons from './RadioButtons';
import ProcessedText from './ProcessedText';

interface Subcomponents {
  Actions: typeof Actions;
  Count: typeof Count;
  Header: typeof Header;
  RadioButtons: typeof RadioButtons;
  ProcessedText: typeof ProcessedText;
}

export interface WebformAssessmentProps {
  id: string;
  children: React.ReactNode;
}

const WebformAssessment: React.FC<WebformAssessmentProps> & Subcomponents = ({ id, children }) => (
  <Wrapper id={id} className="WebformAssessment">
    <Header />

    <main>
      <div className="WebformAssessment__content">
        <Container>
          <div className="row">
            <div className="col-12">
              {children}
            </div>
          </div>
        </Container>
        <SwirlIllustrations variant={7} />
      </div>
    </main>
  </Wrapper>
);

WebformAssessment.Actions = Actions;
WebformAssessment.Count = Count;
WebformAssessment.Header = Header;
WebformAssessment.RadioButtons = RadioButtons;
WebformAssessment.ProcessedText = ProcessedText;

export default WebformAssessment;
